import React, { useState } from "react";
import { Card } from "react-bootstrap";

/**
 * 
 * @param {props} isSelected boolean true if this card is selected
 * @param {props} otherSelected boolean true if other is selected
 * @param {props} icon html element of icon or image
 * @param {props} desc string card description under icon
 * @param {props} color string of which color should be used for border/text
 * @param {props} clickHandler function what happens on click 
 * 
 * @returns boorstrap Card
 */
const HoverCard = ({isSelected, disabled, icon, desc, color, clickHandler}) => {

    const [hover, setHover] = useState(false);
    const textColor = `text-${color}`;
    const borderColor = `border-${color}`;
    const bgColor = `bg-${color}`;

    return (
        <Card
            key={desc}
            onMouseEnter={() =>disabled === undefined? setHover(true) :null}
            onMouseLeave={() => setHover(false)}
            style={disabled? {opacity: 0.4, background: "lightgray"} : null}
            className={isSelected? `shadow-lg ${bgColor} text-white`: hover? `shadow-lg ${borderColor} ${textColor}`: null}
            onClick={disabled === undefined? clickHandler: null}
        >
            <Card.Body className="text-center">
                {icon}
                <br /><br />
                <h5>{desc}</h5>
            </Card.Body>
        </Card>
    )
}

export default HoverCard;